import { render } from "./FormContact.vue?vue&type=template&id=db76803e&scoped=true"
import script from "./FormContact.vue?vue&type=script&lang=js"
export * from "./FormContact.vue?vue&type=script&lang=js"

import "./FormContact.vue?vue&type=style&index=0&id=db76803e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db76803e"]])

export default __exports__